import React from 'react';

const Feedback = () => <div>feedback</div>;

export default Feedback;
